import { IsNotEmpty, IsNumber, IsPositive } from "class-validator";

export class UserExternalInvestDto{
    @IsNotEmpty()
    email:string = '';
    @IsNotEmpty()
    @IsPositive()
    @IsNumber()
    tokens: number = 0;
    error?: string;

    constructor (email: string = '', tokens: number = 0, error?: string) {
        this.email = email;
        this.tokens = tokens;
        this.error = error;
    }
}